import { useSyncExternalStore } from 'react';

/**
 * A partir de que largura o detalhe da aba Tarefas vira painel fixo.
 *
 * `lg` (1024 px), e nao `md`: com a barra lateral (`w-sidebar`) e o painel
 * (`w-detail`, 360 px) ocupando espaco, no `md` sobrariam uns 170 px para a
 * lista — menos que o titulo de uma tarefa. Entre `md` e `lg` continua a gaveta
 * lateral sobreposta, que nao rouba largura da lista.
 */
const CONSULTA = '(min-width: 1024px)';

function assinar(avisar: () => void) {
  const consulta = window.matchMedia(CONSULTA);
  consulta.addEventListener('change', avisar);
  return () => consulta.removeEventListener('change', avisar);
}

/**
 * `true` quando a tela comporta lista e detalhe lado a lado.
 *
 * Por `matchMedia` no JS, e nao so por classe responsiva: a diferenca nao e de
 * estilo, e de COMPORTAMENTO — no painel fixo salvar nao fecha o detalhe, o
 * estado vazio existe e o elemento deixa de ser um dialogo. `useSyncExternalStore`
 * acompanha a janela redimensionada (ou o tablet girado) sem um estado copiado.
 */
export function usePainelFixo(): boolean {
  return useSyncExternalStore(assinar, () => window.matchMedia(CONSULTA).matches);
}
